import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.781 4.781A2.667 2.667 0 0 1 6.6668 4h8.8889a1.7776 1.7776 0 0 1 1.7777 1.7778v1.7778a1.778 1.778 0 0 1 1.7778 1.7777V12a.8888.8888 0 0 1-1.6839.3975l-1.5321-3.0642H6.6667c-.3058 0-.606-.0525-.889-.1525v8.1525a.889.889 0 0 0 .889.8889h10.6666v-2.6666c0-.491.398-.8889.8889-.8889a.889.889 0 0 1 .8889.8889v2.6666A1.778 1.778 0 0 1 17.3333 20H6.6667A2.667 2.667 0 0 1 4 17.3333V6.6667c0-.7073.281-1.3855.781-1.8856m.9968 1.8857a.889.889 0 0 0 .8889.8889h8.8889V5.7778h-8.889a.889.889 0 0 0-.8888.8889",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.5556 12.8889a.8889.8889 0 1 0 0 1.7778h2.6666v-1.7778zm-1.8857-.9967a2.667 2.667 0 0 1 1.8857-.7811h3.5555A.889.889 0 0 1 20 12v3.5556a.889.889 0 0 1-.8889.8888h-3.5555a2.6667 2.6667 0 0 1-1.8857-4.5522",
        clipRule: "evenodd"
    }, "1")
], "Wallet", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
